import type { PageData } from '~/assets/bindings'

export default <T>(fallback: T): Ref<T> => {
  // saved on server
  const page = useDocument()
  const db = useDatabase()

  const query = computed(() => `select * from page_data where page = '${page.value._id}'`)

  const pageData = useQuery<PageData, string>(db, 'pageData', query, (i) => i.page)

  return computed<T>({
    get: () => {
      const fromServer = pageData.value[page.value._id]
      return fromServer ? JSON.parse(fromServer.data) : fallback
    },
    set: (val: T) => {
      db.value?.reducers.setPageData(page.value._id, JSON.stringify(val))
    },
  })
}
